import { render } from "./CreateInitialHoldForm.vue?vue&type=template&id=82d1565a&scoped=true&ts=true&lang=pug"
import script from "./CreateInitialHoldForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateInitialHoldForm.vue?vue&type=script&lang=ts&setup=true"

import "./CreateInitialHoldForm.vue?vue&type=style&index=0&id=82d1565a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d1565a"]])

export default __exports__